import React, { Component } from 'react';
import {repoName} from '../helpers/helpers.js';
import jquery from 'jquery';

/**
 * Display the last repos with builds
 */
export class LastRepos extends Component {
  constructor(props) {
    super(props);
    this.state = {data: []};

    /* make it possible to access the real this */
    this.buildEvent = this.buildEvent.bind(this);
  }

  noData() {
    return <p className="no-data">No repository data</p>;
  }

  /*
   * We have selected a build inside a repository
   */
  buildEvent(e) {
    const id = e.target.id;
    this.props.onBuildEvent(id);
  }

  render() {
    const builds = this.state.data.map(entry =>
        (<li key={entry.id}>
          <div className="last-build-entry">
            <p className="last-build-left">Repo: <i className="fa fa-github" aria-hidden="true"/> {repoName(entry.repo_url)}</p>
            <p className="last-build-left">CI Build #{entry.build_number}</p>
            <p className="last-build-left">
              <a id={entry.id} href="#" onClick={this.buildEvent}>Browse test results</a>
            </p>
          </div>
         </li>));
    if (builds.length === 0)
      return (
        <div className="last-build-builds">
          <h2>Last builds</h2>
          {this.noData()}
        </div>);

    return (
        <div className="last-build-builds">
          <h2>Last builds</h2>
          <ul className="last-build-list">
            {builds}
          </ul>
        </div>);
  }

  componentDidMount() {
    jquery.getJSON('https://api.bob-bench.org/v1/lastRuns').done(function(data) {
      /* load the first build on first load */
      if (data.length > 0)
        this.props.onBuildEvent(data[0].id);
      this.setState({data: data});
    }.bind(this)).fail(function(error, a, b) {
    });
  }
}




// WEBPACK FOOTER //
// ./src/components/LastRepos.js